import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M12.5 6C12.5 5.125 12 4.3125 11.25 3.84375C10.4688 3.40625 9.5 3.40625 8.75 3.84375C7.96875 4.3125 7.5 5.125 7.5 6C7.5 6.90625 7.96875 7.71875 8.75 8.1875C9.5 8.625 10.4688 8.625 11.25 8.1875C12 7.71875 12.5 6.90625 12.5 6ZM6 6C6 4.59375 6.75 3.28125 8 2.5625C9.21875 1.84375 10.75 1.84375 12 2.5625C13.2188 3.28125 14 4.59375 14 6C14 7.4375 13.2188 8.75 12 9.46875C10.75 10.1875 9.21875 10.1875 8 9.46875C6.75 8.75 6 7.4375 6 6ZM4.53125 16.5H15.4375C15.1563 14.5312 13.4688 13 11.4063 13H8.5625C6.5 13 4.8125 14.5312 4.53125 16.5ZM3 17.0938C3 14 5.46875 11.5 8.5625 11.5H11.4063C14.5 11.5 17 14 17 17.0938C17 17.5938 16.5625 18 16.0625 18H3.90625C3.40625 18 3 17.5938 3 17.0938Z"
	})
});
const ForwardRef = forwardRef(SvgUserOutlined);
export default ForwardRef;
